import { useMemo } from 'react';
/**
 * Computes the `{ from, to, total }` page window. Clamps the window so it stays valid (`from <= to`)
 * when total is 0, or when `page` is momentarily out of range after `total` shrinks (e.g. a filter
 * reduces the result set before the caller resets the page). This only affects what's shown — it
 * does not reset page state; see usePagination's note for the caller's responsibility.
 */
export const getPageInfo = ({ page, perPage, total }) => {
    const maxPage = total === 0 ? 0 : Math.ceil(total / perPage) - 1;
    const safePage = Math.min(page, maxPage);
    return {
        from: total === 0 ? 0 : safePage * perPage + 1,
        to: Math.min(total, (safePage + 1) * perPage),
        total,
    };
};
export const usePageInfo = ({ page, perPage, total }) => useMemo(() => getPageInfo({ page, perPage, total }), [page, perPage, total]);
